import { Component, Input } from '@angular/core';
import { AutomationIdDirective } from '@innogy/utils-automation-id';

@Component({
  selector: 'wl-not-found[title]',
  templateUrl: './not-found.component.html',
  styleUrls: ['not-found.component.ed.scss', 'not-found.component.essent.scss'],
  standalone: true,
  imports: [AutomationIdDirective],
})
export class NotFoundComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() title!: string;
}
